<template>
    <div>
        <transition appear name="loading-bar">
            <loading-bar v-show="pending" />
        </transition>

        <b-card-header class="d-flex justify-between align-items-end">
            <slot :params="params" name="header" />
            <b-form inline @submit.prevent="fetchData">
                <b-form-group
                    :invalid-feedback="form.errors.get('date')"
                    :label="$t('Date')"
                    :state="form.errors.has('date') ? false : null"
                    class="mb-2 mr-sm-2"
                    label-for="date"
                    label-sr-only
                >
                    <b-form-datepicker
                        id="date"
                        v-model="form.date"
                        :locale="$i18n.locale"
                        :state="form.errors.has('date') ? false : null"
                        reset-button
                    />
                </b-form-group>

                <b-form-group
                    :invalid-feedback="form.errors.get('minutes')"
                    :label="$t('Break length')"
                    :state="form.errors.has('minutes') ? false : null"
                    class="mb-2 mr-sm-2"
                    label-for="minutes"
                    label-sr-only
                >
                    <b-input-group>
                        <b-form-input
                            id="minutes"
                            v-model="form.minutes"
                            min="1"
                            type="number"
                        />
                        <b-input-group-append is-text>
                            min
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>

                <b-button
                    :disabled="pending"
                    class="mb-2"
                    type="submit"
                    variant="primary"
                >
                    {{ $t("Search") }}
                    <b-spinner v-if="pending" small />
                    <fa v-else class="ml-1" icon="search" />
                </b-button>
            </b-form>
        </b-card-header>

        <b-card-body class="align-items-center">
            <no-results-found v-if="!pending && !items.length" class="mb-0" />

            <ul v-if="items.length" class="timeline">
                <break-history-item
                    v-for="revision in items"
                    :key="revision.id"
                    :revision="revision"
                />
            </ul>
        </b-card-body>

        <b-card-footer v-if="showPagination">
            <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                align="center"
                class="mb-0"
            />
        </b-card-footer>
    </div>
</template>

<script>
    import fetchPaginatedData from "@/mixins/fetchPaginatedData";
    import BreakHistoryItem from "@/components/BreakHistoryItem";
    import Form from "vform";

    export default {
        name: 'BreakHistory',
        components: {BreakHistoryItem},
        mixins: [fetchPaginatedData],
        props: {
            apiUrl: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                form: new Form({
                    date: this.$moment().format('YYYY-MM-DD'),
                    minutes: 30
                }),
            }
        },
        methods: {
            fetchData() {
                if (this.pending) {
                    return
                }

                this.pending = true;

                this.form
                    .get(this.apiUrl, {params: this.form.data(), page: this.currentPage})
                    .then(({data}) => {
                        this.setData(data);
                    })
                    .catch(e => {
                        if (!e.response) {
                            throw e;
                        }
                    })
                    .finally(() => {
                        this.pending = false;
                    });

            },
        }
    };
</script>
